import React, { useRef, useState } from 'react';
import { Button, message } from 'antd';
import { CameraOutlined } from '@ant-design/icons';
import { useAppDispatch } from '../../../hooks/redux';
import { updateUserAvatar } from '../../../services';
import { validateImageFile } from '../../../utils/uploadValidation';
import { ProfileAvatarUploaderProps } from '../../interfaces';

const ProfileAvatarUploader = ({ user }: ProfileAvatarUploaderProps) => {
  const dispatch = useAppDispatch();
  const inputRef = useRef<HTMLInputElement>(null);
  const [isUploading, setIsUploading] = useState(false);

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    event.target.value = '';

    if (!file || !user?.id) {
      return;
    }

    const validationError = validateImageFile(file);
    if (validationError) {
      message.error(validationError);
      return;
    }

    setIsUploading(true);
    try {
      await dispatch(updateUserAvatar({ userId: user.id, file })).unwrap();
      message.success('Profile photo updated.');
    } catch (error) {
      message.error(typeof error === 'string' ? error : 'Failed to upload profile photo.');
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="user-profile__avatar">
      <Button icon={<CameraOutlined />} loading={isUploading} disabled={!user?.id} onClick={() => inputRef.current?.click()}>
        {user?.avatar?.publicUrl ? 'Change photo' : 'Add photo'}
      </Button>
      <input
        ref={inputRef}
        className="user-profile__avatar-input"
        type="file"
        accept="image/jpeg,image/png,image/webp"
        onChange={handleFileChange}
      />
    </div>
  );
};

export default ProfileAvatarUploader;
